import React, { useMemo } from "react";

import _ from "lodash";
import qs from "qs";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

import { BugOutlined } from "@ant-design/icons";

import { UserRoute } from "../../../../routes";
import { IntegrationErrorsTypeSample, IntegrationErrorType } from "../../../../store/integration_errors/types";
import { RootState } from "../../../../store/root_reducer";

export interface DebugLinkProps {
  errorType: IntegrationErrorType;
}

export const DebugLink: React.FC<DebugLinkProps> = (props) => {
  const gateId = useSelector((state: RootState) => state.User.selectedGate.id);
  const samplesMap = useSelector((state: RootState) => state.IntegrationErrors.samples);

  const link = useMemo(() => {
    const sample = samplesMap[_.camelCase(props.errorType) as keyof IntegrationErrorsTypeSample];
    return sample ? `${UserRoute.Debug}?${qs.stringify({ gateId, ...sample })}` : "";
  }, [gateId, samplesMap, props.errorType]);
  return link ? (
    <Link to={link}>
      <BugOutlined />
    </Link>
  ) : (
    <></>
  );
};
